@if (leerling$ | async) {
	<div class="dashboard-aanwezigheid-statistieken">
		<app-filter-bar></app-filter-bar>
		<app-filter-panel
			[defaultFilters]="defaultFilters"
			[allFilters]="allFilters()"
			[leerlingselectie]="false"
			(filterExpressionsChange)="filterExpressions.set($event)"
			endpoint="/aanwezigheid"
			[permanentFilterExpressions]="permanentFilters()"
			[overrideDefault]="schooljaarFilterOverride()"
		></app-filter-panel>
		<section class="dashboard">
			<app-legenda class="right" [attribute]="['aw_fun_nm_interventielaag']" [keyIsClassName]="true"></app-legenda>
			<div class="container">
				<app-aanwezigheid-per-maand
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					[showDetailsButton]="false"
					[attr.data-exportable]="exportAanwezigheidPerMaand() ? 'true' : null"
				></app-aanwezigheid-per-maand>
				<app-aanwezigheid-redenen
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					[attr.data-exportable]="exportAanwezigheidRedenen() ? 'true' : null"
					[leerlingDetails]="true"
				></app-aanwezigheid-redenen>
				<app-aanwezigheid-per-schooldag
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					[attr.data-exportable]="exportAanwezigheidPerSchooldag() ? 'true' : null"
				></app-aanwezigheid-per-schooldag>
				<app-aanwezigheid-per-lesuur
					[filterExpressions]="filterExpressions()"
					[permanentFilters]="permanentFilters()"
					[attr.data-exportable]="exportAanwezigheidPerLesuur() ? 'true' : null"
				></app-aanwezigheid-per-lesuur>
			</div>
		</section>
	</div>
}
